import React from "react";
import { useLocation } from "react-router-dom";
import { translations } from "../translations";

const PrivacyPolicy = () => {
  const location = useLocation();
  const currentLang = location.pathname.split("/")[1] || "fr";
  const t = translations[currentLang].privacyPolicyPage;

  return (
    <div className="min-h-screen py-12 px-4 md:px-12 text-white">
      <div className="max-w-4xl mx-auto bg-light text-dark rounded-2xl overflow-hidden shadow-2xl p-8 space-y-8">
        <h1 className="text-3xl md:text-4xl font-bold text-orange mb-6 text-center">
          {t.title}
        </h1>

        <section>
          <h2 className="text-2xl font-semibold text-orange mb-2">
            {t.dataCollectionTitle}
          </h2>
          <p className="text-dark">
            {t.dataCollectionContent}
            <span className="font-semibold text-green">{t.collectedData}</span>
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-orange mb-2">
            {t.dataUsageTitle}
          </h2>
          <p className="text-dark">
            {t.dataUsageContent}
            <span className="font-semibold text-green">{t.dataUsageNote}</span>
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-orange mb-2">
            {t.retentionTitle}
          </h2>
          <p className="text-dark">
            {t.retentionContent}
            <span className="font-semibold text-green">{t.retentionDuration}</span>
            {t.retentionEnd}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-orange mb-2">
            {t.dataSharingTitle}
          </h2>
          <p className="text-dark">{t.dataSharingContent}</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-orange mb-2">
            {t.yourRightsTitle}
          </h2>
          <p className="text-dark mb-2">{t.yourRightsIntro}</p>
          <ul className="list-disc list-inside text-dark space-y-1">
            {t.yourRightsList.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          <p className="text-dark mt-2">
            {t.yourRightsContact}
            <span className="font-semibold text-green">{t.contactEmail}</span>
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-orange mb-2">
            {t.securityTitle}
          </h2>
          <p className="text-dark">{t.securityContent}</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-orange mb-2">
            {t.contactTitle}
          </h2>
          <p className="text-dark">
            {t.contactContent}
            <span className="font-semibold text-green">{t.contactEmail}</span>
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
